import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Hotel, Users, LogOut, Shield, FileText, UserPlus } from 'lucide-react';

const navItems = [
  { to: '/superadmin', icon: LayoutDashboard, label: 'Genel Bakış', end: true },
  { to: '/superadmin/hotels', icon: Hotel, label: 'Oteller' },
  { to: '/superadmin/signups', icon: UserPlus, label: 'Kayıtlar' },
  { to: '/superadmin/users', icon: Users, label: 'Kullanıcılar' },
  { to: '/superadmin/logs', icon: FileText, label: 'Sistem Logları' },
];

export default function SuperAdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <aside style={{ width: 240, background: '#0f172a', color: 'white', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Shield size={22} color="#f59e0b" />
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Süper Admin</div>
              <div style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase' }}>Sistem Yönetimi</div>
            </div>
          </div>
        </div>

        <nav style={{ flex: 1, padding: '12px 8px' }}>
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink key={to} to={to} end={end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8,
              color: isActive ? 'white' : '#64748b', background: isActive ? '#f59e0b' : 'transparent',
              textDecoration: 'none', fontSize: 14, fontWeight: 500, marginBottom: 2, transition: 'all 0.15s',
            })}>
              <Icon size={17} />{label}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ padding: '8px 12px', marginBottom: 4, fontSize: 13, color: '#475569' }}>
            {user?.name}
          </div>
          <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', borderRadius: 8, background: 'transparent', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 14, width: '100%' }}>
            <LogOut size={15} /> Çıkış
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, overflow: 'auto', background: '#f8fafc' }}>
        <Outlet />
      </main>
    </div>
  );
}
